import { Fields } from "../../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "../SchemaFactory";
import { UserLoginDTO } from "../../domain/models/dto/UserDTO";

export const userLoginFields: Fields<UserLoginDTO> = {
    email: {
        min: 1,
        max: 128,
        required: {
            value: true,
            key: "login.emailRequired",
        },
        placeholderKey: "login.emailField",
        type: "email",
        initial: "",
    },
    password: {
        min: 8,
        max: 128,
        required: {
            value: true,
            key: "login.passwordRequired",
        },
        placeholderKey: "login.passwordField",
        type: "password",
        initial: "",
    },
};

export const userLoginSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userLoginFields);
};
